"use client";

import { useEffect, useState } from "react";
import type { ReactNode } from "react";
import { cn } from "@/utils";

type RiseWordProps = {
  children: ReactNode;
  /** animation delay in seconds */
  delay?: number;
  className?: string;
};

/**
 * Hero word that rises into place from behind a clipping mask.
 * The mask is released once the animation ends so gradient descenders
 * and italics are not cut off.
 */
const RiseWord = ({ children, delay = 0, className }: RiseWordProps) => {
  const [clipped, setClipped] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setClipped(false), 1400);
    return () => clearTimeout(t);
  }, []);

  return (
    <span
      className={cn(
        "jlt-inline-block jlt-align-bottom",
        clipped ? "jlt-overflow-hidden" : "jlt-overflow-visible"
      )}
    >
      <span
        style={{ animationDelay: `${delay}s` }}
        className={cn(
          "jlt-inline-block jlt-translate-y-[112%] jlt-animate-rise motion-reduce:jlt-translate-y-0 motion-reduce:jlt-animate-none",
          className
        )}
      >
        {children}
      </span>
    </span>
  );
};

export default RiseWord;
